import { PublishingStatus } from '../../lib/types/opportunityTypes'

export const OPPORTUNITY_CURRENCY_OPTIONS = [
  { text: 'USD', value: 'USD' },
  { text: 'AED', value: 'AED' },
  { text: 'GBP', value: 'GBP' },
  { text: 'EUR', value: 'EUR' },
] as const

export const OPPORTUNITY_VISIBILITY_OPTIONS: {
  text: string
  value: PublishingStatus
}[] = [
  { text: 'Published', value: 'PUBLISHED' },
  { text: 'Unpublished', value: 'UNPUBLISHED' },
  { text: 'Private (Link-view)', value: 'LINK_ONLY' },
  { text: 'Closed for Investment', value: 'CLOSED' },
]
